var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckbook = function SvgCheckbook(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "checkbook_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#checkbook_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.75 18.438h8.219q.469 0 .703-.293t.234-.643-.234-.645-.703-.294H8.75a.9.9 0 0 0-.668.27.9.9 0 0 0-.27.667q0 .4.27.668.27.27.668.27m0-5h5q.399 0 .668-.27.27-.27.27-.668a.9.9 0 0 0-.27-.668.9.9 0 0 0-.668-.27h-5a.9.9 0 0 0-.668.27.9.9 0 0 0-.27.668q0 .4.27.668.27.27.668.27m-3.365 9.687a2.18 2.18 0 0 1-1.596-.664 2.18 2.18 0 0 1-.664-1.596V9.135q0-.933.664-1.596a2.18 2.18 0 0 1 1.596-.664h19.23q.933 0 1.596.664.664.663.664 1.596v2.043q0 .398-.27.668a.9.9 0 0 1-.668.27.9.9 0 0 1-.668-.27.9.9 0 0 1-.269-.668V9.135a.37.37 0 0 0-.108-.277.38.38 0 0 0-.277-.108H5.385a.37.37 0 0 0-.277.108.37.37 0 0 0-.108.277v11.73q0 .17.108.277a.37.37 0 0 0 .277.108h8.233q.398 0 .668.27t.27.668-.27.668a.9.9 0 0 1-.668.269zm22.398-7.966a.45.45 0 0 1 .145.32.45.45 0 0 1-.146.32l-1.051 1.052-1.587-1.587 1.052-1.05a.45.45 0 0 1 .321-.147q.175 0 .32.145zM26.005 17.6l-7.697 7.697a.9.9 0 0 1-.316.21 1 1 0 0 1-.362.069h-.707a.46.46 0 0 1-.336-.145.46.46 0 0 1-.145-.336v-.707a.97.97 0 0 1 .28-.677l7.696-7.698z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckbook);
export default ForwardRef;